import { render, staticRenderFns } from "./PageDayCare.vue?vue&type=template&id=b0e6195e&scoped=true&"
import script from "./PageDayCare.vue?vue&type=script&lang=js&"
export * from "./PageDayCare.vue?vue&type=script&lang=js&"
import style0 from "./PageDayCare.vue?vue&type=style&index=0&id=b0e6195e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e6195e",
  null
  
)

export default component.exports